export const EnvBanner = () => {
	const env = APP_ENV;

	if (!env || env.toLowerCase() === 'production') {
		return null;
	}

	return (
		<div className="bg-black py-2 text-center text-sm font-semibold tracking-[0.5rem] text-primary uppercase">
			{env}
		</div>
	);
};
